import { render } from "./BaseHeading.vue?vue&type=template&id=6ad7965a&scoped=true&ts=true"
import script from "./BaseHeading.vue?vue&type=script&lang=ts"
export * from "./BaseHeading.vue?vue&type=script&lang=ts"

import "./BaseHeading.vue?vue&type=style&index=0&id=6ad7965a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad7965a"]])

export default __exports__